import React from "react";
import {AisinoCol, AisinoRow} from "../../baseComponent/rowAndCol";
import {AisinoFormItem} from "../../baseComponent/form";
import {buttonLayout} from "../../constant/css";
import {AisinoSpace} from "../../baseComponent/space";
import {AisinoButton} from "../../baseComponent/button";
import SaveOutlined from "@ant-design/icons/es/icons/SaveOutlined";
import CheckSquareOutlined from "@ant-design/icons/es/icons/CheckSquareOutlined";
import CloseSquareOutlined from "@ant-design/icons/es/icons/CloseSquareOutlined";
import FileDoneOutlined from "@ant-design/icons/es/icons/FileDoneOutlined";
import {getLanguage} from "../../source/js/common";

const commonLan = require('../../constant/js/formItemNameLabel/'+getLanguage()+'/common.js');


class FormBottomButton extends React.Component {
    render() {
        return (
            <AisinoRow gutter={24}>
                <AisinoCol span={24}>
                    <AisinoFormItem {...buttonLayout}>
                        <AisinoSpace>
                            <AisinoButton icon={<SaveOutlined />}
                                          type="primary" htmlType="submit"
                                          onClick={this.props.clickSave}
                                          disabled={this.props.saveButtonDisabled}
                                          style={{'display':(this.props.saveButtonDisplay?'':'none')}}>
                                {commonLan.saveButton.label}
                            </AisinoButton>
                            <AisinoButton icon={<CheckSquareOutlined />} type="primary" htmlType="submit"
                                          onClick={this.props.clickSubmit}
                                          disabled={this.props.submitButtonDisabled}
                                          style={{'display':(this.props.submitButtonDisplay?'':'none')}}>
                                {commonLan.submitButton.label}
                            </AisinoButton>
                            <AisinoButton icon={<FileDoneOutlined />}
                                          onClick={this.props.clickOk}
                                          disabled={this.props.okButtonDisabled}
                                          style={{'display':(this.props.okButtonDisplay?'':'none')}}>
                                {commonLan.okButton.label}
                            </AisinoButton>
                            <AisinoButton icon={<CloseSquareOutlined />}
                                          onClick={this.props.clickCancel}
                                          disabled={this.props.cancelButtonDisabled}
                                          style={{'display':(this.props.cancelButtonDisplay?'':'none')}}>
                                {commonLan.cancelButton.label}
                            </AisinoButton>
                            <AisinoButton icon={<CloseSquareOutlined />}
                                          onClick={this.props.clickClose}
                                          disabled={this.props.closeButtonDisabled}
                                          style={{'display':(this.props.closeButtonDisplay?'':'none')}}>
                                {commonLan.closeButton.label}
                            </AisinoButton>
                        </AisinoSpace>
                    </AisinoFormItem>
                </AisinoCol>
            </AisinoRow>
        );
    }
}
export default FormBottomButton;